var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import APIMap from "../api_map.js";
import axios from "axios";
import getIP from "../getIP.js";
var IP = getIP();
export function getAllPaymentProviders(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var config, url, response;
        var queryKey = _b.queryKey;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(queryKey[1]),
                        },
                    };
                    url = IP + APIMap("getAllPaymentProviders");
                    return [4 /*yield*/, axios.get(url, config)];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function getPaymentProviderById(options) {
    return __awaiter(this, void 0, void 0, function () {
        var url, config, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = IP + APIMap("getPaymentProviderById");
                    url = url.replace("{id}", options.id);
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(options.userDetails.token),
                        },
                    };
                    return [4 /*yield*/, axios.post(url, options.payload, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function requestPayment(url, token, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var config, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = IP + url;
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    };
                    return [4 /*yield*/, axios.post(url, payload, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function checkPaymentStatus(token, txnId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, config, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = IP + APIMap("checkPaymentStatus");
                    url = url.replace("{txnId}", txnId);
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    };
                    return [4 /*yield*/, axios.get(url, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function fetchPaymentStatus(url, token, txnId) {
    return __awaiter(this, void 0, void 0, function () {
        var config, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = IP + url;
                    url = url.replace("{transactionId}", txnId);
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    };
                    return [4 /*yield*/, axios.get(url, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function registrationAPIForEAnd(token, payload) {
    return __awaiter(this, void 0, void 0, function () {
        var config, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    };
                    url = IP + APIMap("registrationForEAnd");
                    return [4 /*yield*/, axios.post(url, payload, config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function finalizationAPIforEAnd(txnId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var url, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = IP + APIMap("finalizationForEAnd");
                    config = null;
                    if (token) {
                        config = {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                            },
                        };
                    }
                    body = {
                        txnId: txnId,
                    };
                    response = null;
                    if (!token) return [3 /*break*/, 2];
                    return [4 /*yield*/, axios.post(url, body, config)];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, axios.post(url, body)];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, response];
            }
        });
    });
}
